import '../../../lib/@skinsoft/offline-mode/src/components/service-worker-lifecycle/register-service-worker';
import '../scss/_main.scss';
import './configure-vue';

import Vue from 'vue';

import { i18n } from '@skinsoft/i18n';
import { Playground } from './app/component/playground';
import { dateTimeFormats, messages } from './locales';
import { router } from './router';

async function mount() {
    new Vue({
        i18n: await i18n(messages, dateTimeFormats),
        render: h => h(Playground),
        router,
    }).$mount('#app');
}

mount();
